(() => {
  angular
    .module('gm.common.directives')
    .directive('gmLineInputIcon', gmLineInputIconDirective);

  function gmLineInputIconDirective() {
    'ngInject';

    return {
      replace: true,
      restrict: 'E',
      scope: {
        width: '@',
        height: '@',
        icon: '@'
      },
      templateUrl: 'modules/common/directives/line-input-icon/line-input-icon.html',
    };
  }
})();
